import axios from "axios";
import { env } from "../config";
const baseUrl =
  env === "local"
    ? "https://testapps-api.trainery.one/api"
    : env === "dev"
    ? "https://testapps-api.trainery.one/api"
    : "https://apps-api.trainery.one/api";

const hostUrl =
  env === "local"
    ? "localhost:3000/"
    : env === "dev"
    ? "testapps.trainery.one/"
    : "apps.trainery.one/";

const axiosInstance = axios.create({
  withCredentials: true,
  baseURL: baseUrl,
  headers: {
    host: hostUrl,
    "User-Agent": "TraineryOne-WebApp/1.0",
  },
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 403) {
      window.location.href = "/session-expiry-logout";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
